import FindMeetingTimeSlot from 'owa-calendar-scheduling-service/lib/schema/FindMeetingTimeSlot';
import PlacesSource from 'owa-service/lib/contract/PlacesSource';
import TimeConstraint from 'owa-calendar-scheduling-service/lib/schema/TimeConstraint';
import TimeSlot from 'owa-service/lib/contract/TimeSlot';
import { addMinutes } from 'owa-datetime/lib/owaDate';
import { formatDate } from 'owa-datetime';
import { utcDate } from 'owa-datetime';

const DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';

/**
 * Create LocationConstraint for FML request
 */
export default function createTimeConstraints(
    source: PlacesSource,
    meetingTimeSlot: TimeSlot
): TimeConstraint {
    let timeslots = [];

    if ((source & PlacesSource.Relevance) == PlacesSource.Relevance && meetingTimeSlot != null) {
        timeslots = [];
        let start = utcDate(meetingTimeSlot.StartTime);
        let end = addMinutes(start, meetingTimeSlot.DurationInMinutes);
        timeslots.push({
            Start: {
                DateTime: formatDate(start, DATE_FORMAT),
                TimeZone: start.tz,
            },
            End: {
                DateTime: formatDate(end, DATE_FORMAT),
                TimeZone: end.tz,
            },
        } as FindMeetingTimeSlot);

        return {
            timeslots: timeslots,
        } as TimeConstraint;
    }

    return null;
}
